

exports.__esModule = true;
exports.$VenmoAuthRoute = undefined;

var _squid = require('squid');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

var _route = require('xo-third-party-components/src/venmo-info-gather/route');

var _route2 = _interopRequireDefault(_route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $VenmoAuthRoute = exports.$VenmoAuthRoute = _squid.$Route.extend('$VenmoAuthRoute', {
    path: 'venmoAuth',
    directive: _directive2['default'],

    auth: false,
    query: [_directive.AUTH_LINK_HATEOS, _directive.NEXT_STATE],

    trackingData: {
        fptiState: 'venmo_remembered_entrypoint',
        trackStateExit: true
    },
    children: [{
        route: _route2['default'],
        attributes: {
            token: 'token',
            sidebar: 'sidebar'
        }
    }]
});

angular.value("$VenmoAuthRoute", $VenmoAuthRoute);
_squid.$Route;

_directive.AUTH_LINK_HATEOS;

_directive.NEXT_STATE;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-venmoAuth/route.js
// module id = ./pages/xo-venmoAuth/route.js
// module chunks = 0